import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../session'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import AddNewButton from './AddNewButton'
import Container from '../../../components/structure/Container'
import ControlBar from './ControlBar'
import FormsLoader from './_load/FormsLoader'
import FormsTable from './table/FormsTable'
import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import PageHeader from './PageHeader'
import Separator from '../../../components/helpers/Separator'
import ShareFormContext from '../share/_context/ShareFormContext'
import ShareFormModal from '../share/ShareFormModal'

const FormsListPage = () => {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <PermissionChecker permission="listForm">
        <Container>
          <PageHeader />
          <FilterHandler>
            <ControlBar />

            <MultiSelectHandler>
              <ShareFormContext>
                <FormsLoader uncontrolledChildren={<MultiRowsActions />}>
                  <FormsTable />
                </FormsLoader>
                <ShareFormModal />
              </ShareFormContext>
            </MultiSelectHandler>
          </FilterHandler>

          <AddNewButton />
          <Separator weight={32} />
        </Container>
      </PermissionChecker>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default FormsListPage
